import { filterInvalidImages } from "@faire/retailer-visitor-shared/lib/filterInvalidImages";
import { isFastly } from "@faire/web/common/images/optimizeImages";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { useQuery } from "@tanstack/react-query";

export const useValidateImage = (image: IImage | undefined) => {
  const { data: validateImageData } = useQuery({
    queryKey: ["validate-image-result", image, image?.url],
    queryFn: async () => {
      if (image?.url && !isFastly(image.url)) {
        return (await filterInvalidImages([image]))[0];
      }
      return image;
    },
  });
  if (!image?.url) {
    return undefined;
  }
  return validateImageData;
};
